


import {
  ProgramItem,
  ProgramBox,
  ProgramContent,
  ProgramFlex,
  ProgramStack,
  ProgramTitle,
  ProgramText,
  ProgramImage,
  useProgram,
} from "planby";

type ProgramType = ProgramItem & {
  doOnClick: () => void
}

export const ProgramItemComp = ({ doOnClick, program, ...rest }: ProgramType) => {
  const { styles, formatTime, set12HoursTimeFormat, isLive, isMinWidth } =
      useProgram({
          program,
          ...rest,
      });

  const { data } = program;
  const { image, title, since, till } = data;

  const sinceTime = formatTime(since, set12HoursTimeFormat()).toLowerCase();
  const tillTime = formatTime(till, set12HoursTimeFormat()).toLowerCase();

  return (
      <button onClick={doOnClick}>
          <ProgramBox width={styles.width } style={styles.position}>
              <ProgramContent width={styles.width} isLive={isLive} style={{ borderRadius: 0, margin: -2, }}>
                  <ProgramFlex>
                      {isLive && isMinWidth && <ProgramImage src={image} alt="" />}
                      <ProgramStack>
                          <ProgramTitle>{title}</ProgramTitle>
                          <ProgramText>
                              {sinceTime} - {tillTime}
                          </ProgramText>
                      </ProgramStack>
                  </ProgramFlex>
              </ProgramContent>
          </ProgramBox>
      </button>
  );
};
